import { toast } from 'sonner';

import type { TaskLinkRelation } from './ActivitiesTaskRowMenu';

import { addDependency } from '@/features/work-management/workTasks.api';


/**
 * Shared handler for the row menu's "Link to" items, used by every table that
 * renders `ActivitiesTaskRowMenu`.
 *
 * The API stores one edge: `POST /work/tasks/:id/dependencies` with `:id` the
 * successor and `predecessorTaskId` the task it waits on.
 *   - "Blocked by" → this task waits on the target:  (this, target)
 *   - "Blocks"     → the target waits on this task:  (target, this)
 *
 * Success and failure messages come from the API (400 cycle / self-link,
 * 409 duplicate). Returns true only when the dependency was stored.
 */
export async function linkTaskDependency(
  taskId: string,
  targetId: string,
  relation: TaskLinkRelation,
): Promise<boolean> {
  const [successorId, predecessorId] =
    relation === 'blocked_by' ? [taskId, targetId] : [targetId, taskId];
  try {
    await addDependency(successorId, predecessorId, 'FINISH_TO_START');
    toast.success('Dependency added');
    return true;
  } catch (error) {
    const e = error as { response?: { data?: { message?: unknown } }; message?: string };
    const apiMessage = e?.response?.data?.message;
    const text = Array.isArray(apiMessage) ? apiMessage.join(', ') : apiMessage;
    toast.error(
      (typeof text === 'string' && text) || e?.message || 'Failed to add dependency',
    );
    return false;
  }
}
